export default __webpack_public_path__ + "static/media/LP2.d2adc988.png";